module.exports = __webpack_public_path__ + "img/singlebroker.05dbba03.svg";